export const NO_GROUP_DROPDOWN_VALUE = {
  key: 'no-group',
  label: 'No group',
  title: 'No group',
  value: 'no-group'
}

export const NO_INSHURANCE_DROPDOWN_VALUE = {
  key: 'no-insurance',
  title: 'No insurance',
  label: 'No insurance',
  value: 'no-insurance'
}

export const NO_MEASUREMENT_DROPDOWN_VALUE = {
  key: 'no-type',
  label: 'No measurement',
  title: 'No measurement',
  value: 'no-type'
}

export const NO_PROBLEM_DROPDOWN_VALUE = {
  key: 'no-disease',
  title: 'No problem',
  value: 'no-disease'
}

export const NO_FACILITY_DROPDOWN_VALUE = {
  key: 'no-facility',
  label: 'No facility',
  title: 'No facility',
  value: 'no-facility'
}

export const NO_FACILITY_TYPE_DROPDOWN_VALUE = {
  key: 'no-facility-type',
  label: 'No Facility Type',
  title: 'No Facility Type',
  value: 'no-facility-type'
}

export const NO_REFSOURCE_DROPDOWN_VALUE = {
  key: 'no-referral-source',
  label: 'No referral source',
  title: 'No referral source',
  value: 'no-referral-source'
}

export const NO_REFERALPAYER_DROPDOWN_VALUE = {
  key: 'no-referral-payer',
  label: 'No referral payer',
  title: 'No referral payer',
  value: 'no-referral-payer'
}

export const NO_AGENCY_MARKETER_DROPDOWN_VALUE = {
  key: 'no-agency-marketer',
  label: 'No agency marketer',
  title: 'No agency marketer',
  value: 'no-agency-marketer'
}

export const NO_AGENCY_CASE_MANAGER_DROPDOWN_VALUE = {
  key: 'no-agency-case-manager',
  label: 'No agency case manager',
  title: 'No agency case manager',
  value: 'no-agency-case-manager'
}

export const NO_CLINICIAN_DROPDOWN_VALUE = {
  key: 'no-clinician',
  label: 'No clinician',
  title: 'No clinician',
  value: 'no-clinician'
}

export const NO_CAREGIVER_DROPDOWN_VALUE = {
  key: 'no-care-giver',
  title: 'No caregiver',
  value: 'no-care-giver'
}

export const NO_ENROLLMENTSPECIALIST_DROPDOWN_VALUE = {
  key: 'no-enrollment-specialist',
  title: 'No enrollment specialist',
  value: 'no-enrollment-specialist'
}

export const OTHER_DROPDOWN_VALUE = {
  key: 'other',
  label: 'Other',
  title: 'Other',
  value: 'other'
}

export const NO_CARE_TEAM_DROPDOWN_VALUE = {
  key: 'no-care-team',
  title: 'No care team',
  label: 'No care team',
  value: 'no-care-team'
}

export const NO_OUTCOME_VALUE = {
  key: 'no-outcome',
  label: 'Not specified',
  value: 'no-outcome'
}

export const NO_REASON_VALUE = {
  key: 'no-reason',
  label: 'Not specified',
  value: 'no-reason'
}

export const NO_PREVENTIVE_TYPE_VALUE = {
  key: 'no-preventive-type',
  label: 'No preventive type',
  value: 'no-preventive-type'
}

export const NO_PROFESSIONAL_TEAM_VALUE = {
  key: 'no-medical-team',
  label: 'No Professional Team',
  title: 'No Professional Team',
  value: 'no-medical-team'
}

export const CUSTOM_VALUE = {
  key: 'custom',
  label: 'Custom',
  title: 'Custom',
  value: 'custom'
}

export const NO_CARE_PLAN_CLINICIAN_DROPDOWN_VALUE = {
  key: 'no-care-plan-clinician',
  label: 'No clinician',
  title: 'No clinician',
  value: 'no-care-plan-clinician'
}

export const NO_REFERRAL_REASON = {
  key: 'no-referral-reason',
  label: 'No referral reason',
  title: 'No referral reason',
  value: 'no-referral-reason'
}

export const NO_ASSIGNED_TO = {
  key: 'no-assigned-to',
  label: 'No Assignee',
  title: 'No Assignee',
  value: 'no-assigned-to'
}

export const NO_TRIAGE_NURSE = {
  key: 'no-triage-nurse',
  label: 'No Triage Nurse',
  title: 'No Triage Nurse',
  value: 'no-triage-nurse'
}

export const NO_REFERRAL_SUBGROUP_VALUE = {
  key: 'no-referral-source-sub-group',
  label: 'No referral sub-group',
  title: 'No referral sub-group',
  value: 'no-referral-source-sub-group'
}

export const NO_BILLING_PROVIDER = {
  key: 'no-billing-provider',
  label: 'No billing clinician',
  title: 'No billing clinician',
  value: 'no-billing-provider'
}

export const NO_TRAINING_STATUS_DROPDOWN_VALUE = {
  key: 'no-training-status',
  label: 'No training',
  title: 'No training',
  value: 'no-training-status'
}

export const NO_PROGRAM = {
  key: 'no-program',
  label: 'Care Plan',
  title: 'Care Plan',
  value: 'no-program'
}
